module.exports = __webpack_public_path__ + "img/logo-ecomdy-media.6613ca79.svg";